import { Flex, Typography } from 'antd';
import { MInput } from '@Components/Base';

import styles from './fields-styles.module.css';

interface SimAddonFieldsProps {
  setValues: React.Dispatch<
    React.SetStateAction<{
      recommendPackage: string;
    }>
  >;
  existingPackage: string;
}

const SimAddonFields: React.FC<SimAddonFieldsProps> = ({
  setValues,
  existingPackage,
}) => {
  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        <div>
          <Typography.Text>Existing Package:</Typography.Text>
          <div>{existingPackage}</div>
        </div>
        <div>
          <Typography.Text>Recommend Package:</Typography.Text>
          <MInput
            name="recommendPackage"
            onChange={(input) =>
              setValues({ recommendPackage: input.target.value })
            }
            placeholder="Type Recommend Package"
          />
        </div>
      </Flex>
    </div>
  );
};

export default SimAddonFields;
